import { dateProvider } from '@/helpers/date'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import { nextMonday, addDays } from 'date-fns'
import taiChiWalkingFWebp from '@/assets/landing/tai-chi-walking-f.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => {
			const nextMondayDate = nextMonday(addDays(new Date(), -1))
			const formattedDate = dateProvider.format(nextMondayDate, 'MMMM do')

			return {
				title: `Monday ${formattedDate}: Tai Chi Walking for Weight Loss Challenge`,
				size: 'small',
				customStyles: {
					marginLeft: '0.5rem',
					marginRight: '0.5rem',
				},
			}
		},

		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return { img: taiChiWalkingFWebp }
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
